@import "../../../variables";

.cancelButton {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 4px;
}

.cancelButton:hover {
  text-decoration: underline;
}

.modalContent {
  padding: 40px;
  background-color: #fff;
  border-radius: 8px;
  max-width: 650px;
  width: 90%;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .modalTitle {
    text-align: center;
    font-size: 28px;
    padding: 10px;
  }

  .modalDescription {
    margin-bottom: 8px;
    color: $NATURAL_500;
  }

  .errorMessage {
    color: red;
    font-family: "Noto Sans JP";
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
  }

  .btnContainer {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
}
